import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { IKTRichText } from "@/types/kontent.types"
import { cn } from "@/lib/utils"
import {
  Link,
  RemixIcon,
  RichTextSync,
  Typography,
} from "@/components/ui/atoms"

export interface IFeatureProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean
  icon?: string
  title: string
  text?: IKTRichText
  link?: string
  linkIconLeft?: string
  linkIconRight?: string
  linkText?: string
}

const Feature = React.forwardRef<HTMLButtonElement, IFeatureProps>(
  (
    {
      className,
      asChild = false,
      icon,
      title,
      text,
      linkIconLeft,
      link,
      linkText,
      linkIconRight,
      ...props
    },
    ref
  ) => {
    const Component = asChild ? Slot : "span"
    return (
      <Component
        className={cn("feature items-baseline", className)}
        ref={ref}
        {...props}
      >
        <div className={cn("mb-6 flex items-center", icon ? "ml-[-48px]" : "")}>
          {icon ? <RemixIcon name={icon} size="md" className="mr-6" /> : null}
          <Typography as="h3" variant="headingXS" className="">
            {title}
          </Typography>
        </div>
        <div>
          {text ? (
            <div className="paragraph-m text-neutral-400">
              <RichTextSync blockTitle={title} body={text} />
            </div>
          ) : null}
          {link ? (
            <div className="flex">
              <Link
                chapters={[title, linkText]}
                variant="ghost"
                className="pb-0 pl-0 pt-6"
                title={title}
                iconLeft={linkIconLeft}
                iconRight={linkIconRight}
                href={link}
              >
                {linkText}
              </Link>
            </div>
          ) : null}
        </div>
      </Component>
    )
  }
)
Feature.displayName = "Feature"

export default Feature
